import { useState } from 'react'
import {
  type Theme,
  CheckIcon,
  Mtds,
  ScreenHeader,
  AppLayout,
  UserFeedback,
  useGoBack,
  useTheme
} from 'prove-common'

type SelectThemeScreenProps = {
  topBar?: React.ReactNode
  sidebar?: React.ReactNode
  useMobileBar?: boolean
}

export const SelectThemeScreen = ({
  topBar,
  sidebar,
  useMobileBar
}: SelectThemeScreenProps) => {
  const goBack = useGoBack('/settings')
  const { theme, setTheme } = useTheme()
  const [selectedTheme, setSelectedTheme] = useState(theme)
  const themeOptions = [
    { value: 'light', label: 'Lys' },
    { value: 'dark', label: 'Mørk' },
    { value: 'system', label: 'Systemvalg' }
  ]

  return (
    <AppLayout sidebar={sidebar} topBar={topBar} useMobileBar={useMobileBar}>
      <ScreenHeader
        title='Velg tema'
        description={
          <p>
            Her velger du hvilket tema du ønsker at applikasjonen skal vises i.
          </p>
        }
      />
      <Mtds.Grid>
        <Mtds.Field
          label='Tema'
          as='select'
          value={selectedTheme}
          options={themeOptions}
          onChange={({ target }) => setSelectedTheme(target.value as Theme)}
        />
        <Mtds.Divider />
        <Mtds.Flex>
          <Mtds.Button data-arrow='left' onClick={goBack}>
            Avbryt
          </Mtds.Button>
          <Mtds.Button
            data-variant='primary'
            onClick={() => {
              if (!selectedTheme)
                return alert('Du må velge et tema for å fortsette.')
              setTheme(selectedTheme)
              goBack()
            }}
          >
            <CheckIcon />
            Lagre
          </Mtds.Button>
        </Mtds.Flex>
      </Mtds.Grid>
      <UserFeedback appName='proveta' />
    </AppLayout>
  )
}
